module.exports = __webpack_public_path__ + "static/media/materprivate.03c7c748.png";